import React from 'react';
import styled from 'styled-components';

const StyledSvg = styled.svg`
  color: var(--way-colors-svgColor);
`;

const HyattCreditCard = () => {
  return (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" width="38" height="38">
      <path
        fill="currentColor"
        transform="translate(3.5625 7.125)"
        d="M2.0306907 4.6504211L28.844309 4.6504211L28.844309 2.1956353L2.0306907 2.1956353L2.0306907 4.6504211ZM2.0306907 21.554365L28.844309 21.554365L28.844309 10.830236L2.0306907 10.830236L2.0306907 21.554365ZM29.245726 0L1.6302197 0C0.73104864 0 0 0.79071438 0 1.7620177L0 21.987982C0 22.960306 0.73104864 23.75 1.6302197 23.75L29.245726 23.75C30.143951 23.75 30.875 22.960306 30.875 21.987982L30.875 1.7620177C30.875 0.79071438 30.143951 0 29.245726 0L29.245726 0ZM21.574436 19.668894L26.048567 19.668894C26.626606 19.668894 27.096972 19.159775 27.096972 18.535366L27.096972 15.59901C27.096972 14.97358 26.626606 14.464462 26.048567 14.464462L21.574436 14.464462C20.995453 14.464462 20.525089 14.97358 20.525089 15.59901L20.525089 18.535366C20.525089 19.159775 20.995453 19.668894 21.574436 19.668894L21.574436 19.668894Z"
        fillRule="evenodd"
      />
    </StyledSvg>
  );
};

export default HyattCreditCard;
